// Spinner.jsx
import React from "react";
// import "./Spinner.css"; // Import your CSS file for styling

const Spinner = () => {
	return (
		<div className='spinner-container'>
			<div className='spinner'></div>
		</div>
	);
};

export default Spinner;
